import { Link } from "react-router-dom";
import { PageHeader, Section, DividerGold } from "@/components/layout/Section";
import { HeartHandshake, Coffee, MapPin, Clock, ArrowRight } from "lucide-react";
import { IMAGES } from "@/constants/branding";

export default function NewHere() {
  return (
    <div data-testid="newhere-page">
      <PageHeader
        kicker="New Here?"
        title="Welcome home. We saved you a seat."
        subtitle="Whether you're checking us out online or planning your first visit, here's everything you need to know."
      />

      <Section>
        <div className="grid lg:grid-cols-12 gap-14 items-center">
          <div className="lg:col-span-6">
            <div className="aspect-[4/5] rounded-[2.5rem] overflow-hidden shadow-xl">
              <img src={IMAGES.community} alt="CLBC family" className="w-full h-full object-cover" />
            </div>
          </div>
          <div className="lg:col-span-6">
            <div className="kicker mb-4">What to expect</div>
            <h2 className="font-serif text-4xl text-royal-800 tracking-tight">Come as you are.</h2>
            <div className="mt-6 space-y-5 text-slate-600 leading-relaxed">
              <p>Our services are Spirit-led, biblical, and warm. Expect passionate worship, life-transforming Word, and genuine community.</p>
              <p>You'll be welcomed, not overwhelmed. There's no dress code — bring yourself and an open heart.</p>
            </div>

            <div className="mt-10 grid sm:grid-cols-2 gap-5">
              <div className="card-soft p-6">
                <div className="w-11 h-11 rounded-full bg-gold/15 text-gold-500 flex items-center justify-center"><Clock className="w-5 h-5" /></div>
                <div className="mt-4 font-serif text-lg text-royal">Sunday · 12:00 noon</div>
                <div className="text-sm text-slate-500">Main worship service</div>
              </div>
              <div className="card-soft p-6">
                <div className="w-11 h-11 rounded-full bg-royal/10 text-royal flex items-center justify-center"><Clock className="w-5 h-5" /></div>
                <div className="mt-4 font-serif text-lg text-royal">Thursday · 7:00 PM</div>
                <div className="text-sm text-slate-500">Midweek service</div>
              </div>
            </div>
          </div>
        </div>
      </Section>

      <Section className="bg-slate-50/70 rounded-[3rem] mx-4">
        <div className="text-center max-w-xl mx-auto">
          <div className="kicker justify-center mb-4">First steps</div>
          <h2 className="font-serif text-4xl text-royal-800">Your journey begins here</h2>
          <DividerGold className="mt-6" />
        </div>
        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {[
            { icon: HeartHandshake, t: "Say hello", d: "Introduce yourself to us — we'd love to know you." , link:"/contact" },
            { icon: Coffee, t: "Attend a service", d: "Join us in person or online this weekend." , link:"/watch-live" },
            { icon: ArrowRight, t: "Get connected", d: "Join a ministry or discipleship group." , link:"/ministries" },
          ].map((c, i) => (
            <div key={i} className="card-soft p-8">
              <div className="w-12 h-12 rounded-full bg-gold/15 text-gold-500 flex items-center justify-center">
                <c.icon className="w-5 h-5" />
              </div>
              <div className="mt-5 font-serif text-2xl text-royal">{c.t}</div>
              <div className="mt-2 text-slate-600 text-sm">{c.d}</div>
              <Link to={c.link} className="mt-5 btn-ghost !px-0">Learn more <ArrowRight className="w-4 h-4" /></Link>
            </div>
          ))}
        </div>
      </Section>
    </div>
  );
}
